import { render, staticRenderFns } from "./CommunityInfo.vue?vue&type=template&id=3f3bdc86&"
import script from "./CommunityInfo.vue?vue&type=script&lang=js&"
export * from "./CommunityInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports